// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"348":"68f83561","371":"74bd92d3","480":"b45c55a2","560":"29fa2a28","920":"c4bd2de5"}[chunkId] + ".chunk.js";
};